import axios from 'axios';
import { refreshAccessToken } from './parazol/core';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 5000,
});

/**
 * Axios interceptor to pass the JWT token if exists
 * @param {import('axios').InternalAxiosRequestConfig} axiosConfig
 * @returns {import('axios').InternalAxiosRequestConfig}
 */
const onRequest = (axiosConfig) => {
  const token = localStorage.getItem('auth');
  const newConfig = { ...axiosConfig };

  if (token) {
    newConfig.headers.Authorization = `Bearer ${token}`;
  }

  return newConfig;
};

/**
 * Axios interceptor to manage API response
 * @param {import('axios').AxiosError & { config: { _retry?: boolean }}} error
 * @returns {Promise<import('axios').AxiosResponse|import('axios').AxiosError>}
 */
const onRejected = (error) => refreshAccessToken(error);

instance.interceptors.request.use(onRequest);
instance.interceptors.response.use((res) => res, onRejected);

export default instance;
